// 判断是否选中
import { ChartMessageItem, MessageMaskType, MessageType } from '../../constants/types';
import React from 'react';
import { CheckBoxView } from '../../components/CheckBoxView';
import { Pressable } from 'react-native';

export const SelectDom = (props: {
	isSelected: boolean;
	item: ChartMessageItem;
	disabled?: boolean;
	onSelected: (item: ChartMessageItem) => void;
}): any => {
	const { item, isSelected, disabled, onSelected } = props;
	const mask = item.mask || 0;

	if (
		mask === MessageMaskType.RECALL ||
		mask === MessageMaskType.DELETED ||
		item.type === MessageType.LOCAL_TIME ||
		item.content === '' ||
		item.type === 'tip' ||
		item.visible !== 0
	) {
		return null;
	}
	return (
		<Pressable style={{ marginTop: 6 }} onPress={() => onSelected(item)}>
			<CheckBoxView value={isSelected} style={{ width: 25, height: 25, marginLeft: 10 }} disabled={disabled} />
		</Pressable>
	);
};
